"use client";

import type { FilterContextValue } from "./types";

/**
 * Initial filters state
 */
export const initialFiltersState: FilterContextValue["filters"] = {
  simple: {},
  advanced: [],
  search: "",
  activeViewId: null,
};

/**
 * Initial UI state
 */
export const initialUiState: FilterContextValue["uiState"] = {
  mode: "simple",
  isOpen: false,
  showAdvancedFilters: false,
  filterOperator: "AND",
  customRangeModal: {
    isOpen: false,
    fieldId: "",
    fieldLabel: "",
  },
};

/**
 * Create initial filters state with optional activeViewId from URL
 */
export function createInitialFiltersState(
  activeViewId: string | null = null
): FilterContextValue["filters"] {
  return {
    ...initialFiltersState,
    activeViewId,
  };
}
